<template>
  <div class="seat-row-item">
    <div class="seat-col" v-for="(col, index) in seatRow" :key="index">
      <!--紧急出口-->
      <div class="exit" v-if="col.col === ''"></div>
      <!--通道-->
      <div class="seat-num" v-else-if="col.col === '='">{{col.row}}</div>
      <!--座位-->
      <div
        class="seat"
        ref="seat"
        v-else
        :class="col.styleclass"
        :data-seat="col.seatNumber"
        @click="onSelectSeat($event, col)"
      ></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    seatRow: Array
  },
  methods: {
    onSelectSeat (event, col) {
      // 校验点击的是否座位
      if (['.', 'N', ''].includes(col.seatStatus)) {
        return false
      }
      // 事件触发更新当前座位
      if (col.styleclass.indexOf('seat-checked-fellow') < 0) {
        this.$emit('selectSeat', col, col.styleclass.indexOf('seat-checked') < 0 ? 'add' : 'remove')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.seat-col {
  .seat {
    width: 19px;
    height: 19px;
    margin: 3px 0;
    background: url(../img/seat3.png) 100% no-repeat;
  }
  .seat-num {
    width: 19px;
    height: 19px;
    line-height: 19px;
    margin: 3px 0;
    font-size: 12px;
    text-align: center;
  }
  /* 最舒适座位 */
  .seat.icon2-seats-comfort {
    background-image: url(../img/seat1.png);
  }
  /* 最受欢迎座位 */
  .seat.icon2-seats-okay {
    background-image: url(../img/seat2.png);
  }
  /* 普通座位 */
  .seat.icon2-seats-ordinary {
    background-image: url(../img/seat3.png);
    cursor: pointer;
  }
  /* 已被他人值机座位 */
  .seat.icon2-seats-select {
    background-image: url(../img/seat4.png);
    cursor: not-allowed;
  }
  /* 不能值机座位 */
  .seat.icon2-seats-exit {
    background-image: url(../img/seat5.png);
  }
  /* 自己选中的座位 */
  .seat.seat-checked {
    background-image: url(../img/seat6.png);
  }
  /* 同程选中的座位 */
  .seat.seat-checked-fellow {
    background-image: url(../img/seat6.png);
    opacity: .7;
  }
  /* 付费座位 */
  .seat.icon2-seats-not-free {
    background-image: url(../img/seat8.png);
  }
  /* 无座位 */
  .seat.icon2-seats-null {
    background: none;
  }
  .exit:nth-child(1) {
    position: relative;
  }
}
@media only screen and (max-width: 768px) {
  .airplane-type-330 {
    .seat-col {
      .seat-num {
        width: 23px;
        height: 23px;
      }
      .seat {
        width: 23px;
        height: 23px;
      }
    }
  }
  .seat-col {
    .seat-num {
      width: 30px;
      height: 30px;
      margin: 3px;
      font-size: 18px;
      text-align: center;
      line-height: 30px;
    }
    .seat {
      width: 30px;
      height: 30px;
      margin: 3px;
      background: url(../img/seat3_m.png) 100% no-repeat;
      background-size: 100%;
    }
    /* 最舒适座位 */
    .seat.icon2-seats-comfort {
      background-image: url(../img/seat1_m.png);
    }
    /* 最受欢迎座位 */
    .seat.icon2-seats-okay {
      background-image: url(../img/seat2_m.png);
    }
    /* 普通座位 */
    .seat.icon2-seats-ordinary {
      background-image: url(../img/seat3_m.png);
      cursor: pointer;
    }
    /* 已被他人值机座位 */
    .seat.icon2-seats-select {
      background-image: url(../img/seat4_m.png);
      cursor: not-allowed;
    }
    /* 不能值机座位 */
    .seat.icon2-seats-exit {
      background-image: url(../img/seat5_m.png);
    }
    /* 自己选中的座位 */
    .seat.seat-checked {
      background-image: url(../img/seat6_m.png);
    }
    /* 同程选中的座位 */
    .seat.seat-checked-fellow {
      background-image: url(../img/seat6_m.png);
      opacity: .7;
    }
    /* 付费座位 */
    .seat.icon2-seats-not-free {
      background-image: url(../img/seat8_m.png);
    }
    /* 无座位 */
    .seat.icon2-seats-null {
      background: none;
    }
  }
}
</style>
